export const messages = {
  page: {
    singleSignOnLogout: {
      id: 'singleSignOn.LogoutMessage',
      defaultMessage: 'Your session has ended and you have been logged out. You can now close this page.',
    },
    singleSignOnLogoutTitle: {
      id: 'singleSignOn.LogoutTitle',
      defaultMessage: 'Logout Successful',
    },
  },
};
